import { faFacebook, faInstagram, faThreads, faTiktok } from '@fortawesome/free-brands-svg-icons'

export const SOCIAL_LINKS = [
  { label: 'Threads', href: 'https://www.threads.com/@dropifyid', icon: faThreads },
  { label: 'Instagram', href: 'https://www.instagram.com/dropifyid/', icon: faInstagram },
  { label: 'TikTok', href: 'https://www.tiktok.com/@dropifygrosirsurabaya', icon: faTiktok },
  { label: 'Facebook', href: 'https://www.facebook.com/DropifyPusatGrosir', icon: faFacebook },
]
